import { CustodianProfileStatusEnum } from 'src/graphql/schema';
import { OtherCustodianProfileStatusEnum } from 'src/shared/constants';

export const custodianProfileStatusMap = {
  [CustodianProfileStatusEnum.Active]: {
    label: 'Active',
    color: 'text-green-800',
    bgColor: 'bg-green-100',
  },
  [CustodianProfileStatusEnum.Draft]: {
    label: 'Draft',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
  },
  [CustodianProfileStatusEnum.AccessSetup]: {
    label: 'Pending Activation',
    color: 'text-gray-800',
    bgColor: 'bg-gray-100',
  },
  [CustodianProfileStatusEnum.Terminated]: {
    label: 'Terminated',
    color: 'text-rose-800',
    bgColor: 'bg-rose-100',
  },
  [OtherCustodianProfileStatusEnum.TerminationRequested]: {
    label: 'Termination Requested',
    color: 'text-rose-800',
    bgColor: 'bg-rose-100',
  },
};
